const columnWidths: Record<string, Record<string, number>> = {
    hr: {
        checkbox: 40,
        internalAppId: 60,
        contactCompanyName: 150,
        taxNumber: 120,
        contactCountry: 120,
        city: 120,
        street: 150,
        streetNumber: 100,
        contactStatus: 130,
        lastContactProfile: 100,
        contactProfileStatus: 150,
        contactPhone1: 150,
        contactPhone2: 150,
        contactEmail: 180,
        previousActivityDate: 170,
        nextActivityDate: 170,
        agent: 150,
        initialContactDate: 230,
        priceTo: 170,
        dataSource: 150,
        notes: 230,
        nextActivity: 150,
        actions: 80,
    },
    // Add locale overrides below — only specify columns that differ from hr.
    sl: {
        taxNumber: 140,
        streetNumber: 100,
        lastContactProfile: 120,
    },
    en: {
        streetNumber: 130,
        dataSource: 130,
    },
    de: {
        taxNumber: 140,
    },
    it: {},
}

export default columnWidths
